import { faArrowsTurnToDots } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QueueDetailButton from "entities/QueueDetailsButton/QueueDetailButton";
import { useMemo } from "react";
import { Accordion as BootstrapAccordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useBreakpoints } from "shared/hooks";
import { Table } from "shared/ui";
import "style/requests.css";

const CardRequestsAccordionItem = ({
  item,
  index,
  tabKey,
  data,
  loading,
  cardFormat,
}) => {
  const {
    title,
    apiKey,
    table: { columns, filtered, paginated },
  } = item;

  const accessors = columns.map((column) => column.accessor);
  const rows = data[apiKey]?.data;

  const { breakpoints } = useBreakpoints();

  const actions = useMemo(() => {
    return [
      {
        accessor: "details",
        action: (el) => (
          <QueueDetailButton
            as={Link}
            to={
              "/" +
              (cardFormat === "corporate" ? "corporate" : "cards") +
              "-requests/details/" +
              el.number
            }
            isMobile={breakpoints.xs}
          />
        ),
      },
    ];
  }, [breakpoints.xs]);

  return (
    <BootstrapAccordion.Item
      eventKey={index}
      key={index}
      id={`card-${tabKey}-requests-accordion-test-id-${index}`}
    >
      <BootstrapAccordion.Header>
        <FontAwesomeIcon icon={faArrowsTurnToDots} className="mx-3" />
        {title}: {data[apiKey]?.data.length}
      </BootstrapAccordion.Header>
      <BootstrapAccordion.Body>
        {rows != null && (
          <Table
            {...{
              rows,
              loading,
              filtered,
              paginated,
              accessors,
              actions,
              config: {
                columns,
              },
            }}
          />
        )}
      </BootstrapAccordion.Body>
    </BootstrapAccordion.Item>
  );
};

export default CardRequestsAccordionItem;
